import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { InputWithOptions, Button } from 'wix-style-react'
import EditIcon from 'react-icons/lib/fa/edit'
import DeleteIcon from 'react-icons/lib/md/delete'
import * as _ from 'lodash'

import whimmIcon from 'assets/whimmIcon.png'
import shopifyIcon from 'assets/shopifyIcon.png'
import Pagination from 'components/shared/Pagination'
import { HELVETICA, BLUE, RED, CustomScrollBar } from 'components/styles'
import { api } from 'api/integrationAPI'
import ProductCard from 'components/editor/productCards/ProductCard'
import * as integrationType from 'constants/integrationType'
import Text from 'components/common/Text'

const ProductsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  _flex-wrap: wrap;
  _height: 100%;
`
const ProductsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  flex: 12;
  overflow: auto;

  ${CustomScrollBar}
`
const SearchInputContainer = styled.div`
  width: 100%;
  flex: 1;
`
const OptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 4em;
  ${props => props.bckg ? 'background-color: #f0fffc;' : ''};
  cursor: pointer;
`
const ImageContainer = styled.div`
  margin-left: 1em;
  width: 3em;
  height: 3em;
`
const Image = styled.img`
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
`
const InfoOptionContainer = styled.div`
  flex: 1;
  margin-left: 1em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`
const ProductLink = styled.div`
  ${HELVETICA}
  font-size: 8px;
`
const StoreImageContainer = styled.div`
  margin-right: 1em;
  width: 1.5em;
  height: 1.5em;
`
const OverlayContainer = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(242, 246, 248, 0.4);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
const AdditionalButtonsContainer = styled.div`
  position: absolute;
  bottom: 0.5em;
  left: 0.5em;
  right: 0.5em;
  height: 2em;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`
const PaginationContainer = styled.div`
  margin-top: 1em;
  align-self: center;
`
const ProductsContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`

class ProductsList extends Component {

  constructor (props) {
    super(props)
    this.ownProducts = this.getOwnProducts(props.productsDict)
    this.state = {
      searchString: '',
      selectedId: props.productId,
      activePage: 1
    }
  }


  componentWillReceiveProps (nextProps) {
    let activePage = this.state.activePage
    if (!_.isEqual(this.props.productId, nextProps.productId)) activePage = 1

    const selectedId = nextProps.productId

    if (!_.isEqual(this.props.productsDict, nextProps.productsDict)) {
      this.ownProducts = this.getOwnProducts(nextProps.productsDict)
      this.setState({
        selectedId,
        activePage
      })
    } else if (selectedId !== this.state.selectedId) {
      this.setState({
        selectedId,
        activePage
      })
    }
  }

  getSelectedId = (props) => _.get(props.productInfo, ['productId'], '')

  getOwnProducts (productsDict) {
    const res = []
    for (const pId in productsDict) {
      res.push(api.getProductInfo({productId: pId}, productsDict))
    }
    return res
  }

  onSelectProduct = (product) => {
    return (e) => {
      e.preventDefault()
      this.props.onSelectProduct(product)
    }
  }

  onDeleteClick = (product) => {
    return (e) => {
      e.stopPropagation()
      this.props.onDeleteProduct(product.productId)
    }
  }

  onEditClick = (product) => {
    return (e) => {
      e.stopPropagation()
      this.props.onEditProduct(product.productId)
    }
  }

  renderOverlayAdditionalButtons (product) {
    const { productsDict } = this.props
    if (_.has(productsDict, product.productId)) {
      return (
        <AdditionalButtonsContainer>
          <Button theme='icon-whitesecondary' onClick={this.onEditClick(product)}>
            <EditIcon size='24' color={BLUE} />
          </Button>
          <Button theme='icon-whitesecondary' onClick={this.onDeleteClick(product)}>
            <DeleteIcon size='24' color={RED} />
          </Button>
        </AdditionalButtonsContainer>
      )
    }
  }

  renderProductOverlay = (product) => {
    return (
      <OverlayContainer>
        {/* <Button height='small' onClick={this.onSelectProduct(product)}>Select</Button> */}
        {this.renderOverlayAdditionalButtons(product)}
      </OverlayContainer>
    )
  }

  storeIconByProduct = (product) => {
    const type = _.get(product, ['details', 'storeIcon'])
    if (type === integrationType.SHOPIFY) {
      return shopifyIcon
    } else {
      return whimmIcon
    }
  }

  renderProduct = (product) => {
    const { selectedId } = this.state
    const isSelected = product.productId.toString() === selectedId
    // console.log('product.productId', product.productId, 'selectedId', selectedId, 'isSelected', isSelected)
    return (
      <ProductCard
        key={product.productId}
        onClick={this.onSelectProduct(product)}
        isSelected={isSelected}
        imageUrl={_.get(product, ['details', 'images', 0])}
        title={product.title}
        overlay={this.renderProductOverlay(product)}
        storeIcon={this.storeIconByProduct(product)}
      />
    )
  }

  renderOption = (product, i) => {
    const value = (
      <OptionContainer key={product.productId} bckg={i % 2}>
        <ImageContainer>
          <Image src={_.get(product, ['details', 'images', 0])} />
        </ImageContainer>
        <InfoOptionContainer>
          <Text size='medium'>{product.title}</Text>
          <ProductLink>{product.productLink}</ProductLink>
        </InfoOptionContainer>
        <StoreImageContainer>
          <Image src={this.storeIconByProduct(product)} />
        </StoreImageContainer>
      </OptionContainer>
    )
    return { id: product.productId, value, product, overrideStyle: true }
  }

  onChange = (e) => {
    // console.log('onChane', e.target.value)
    this.setState({
      searchString: e.target.value
    })
  }

  onSelect = (v) => {
    this.props.onSelectProduct(v.product)
  }

  renderSearchInput (products) {
    const { searchString } = this.state
    let filteredProducts = []
    if (searchString !== '') {
      filteredProducts = _.filter(products, p => p.title.toLowerCase().indexOf(searchString.toLowerCase()) !== -1)
    }
    const options = _.map(_.take(filteredProducts, 20), this.renderOption)
    // console.log('options', options)
    return (
      <SearchInputContainer>
        <InputWithOptions
          placeholder='Search Shopify Products or past product links'
          value={searchString}
          onChange={this.onChange}
          options={options}
          // selectedId={selectedId}
          onSelect={this.onSelect}
          maxHeightPixels={800}
        />
      </SearchInputContainer>
    )
  }

  onPaginationChange = (v) => {
    this.setState({
      activePage: v
    })
  }


  render () {
    const { activePage } = this.state
    const { availableProducts, showNoneProduct, itemsCountPerPage } = this.props
    const products = _.clone(this.ownProducts).concat(availableProducts)
    if (showNoneProduct) {
      products.unshift({productId: '', title: 'None'})
    }
    const productsOnPage = _.slice(products, itemsCountPerPage * (activePage - 1), itemsCountPerPage * activePage)

    return (
      <ProductsListContainer>
        {this.renderSearchInput(products)}
        <ProductsContainerWrapper>
          <ProductsContainer>
            {_.map(productsOnPage, this.renderProduct)}
          </ProductsContainer>
        </ProductsContainerWrapper>
        <PaginationContainer>
          <Pagination
            activePage={activePage}
            itemsCountPerPage={itemsCountPerPage}
            totalItemsCount={products.length}
            pageRangeDisplayed={5}
            onChange={this.onPaginationChange}
          />
        </PaginationContainer>
      </ProductsListContainer>
    )
  }

}

ProductsList.defaultProps = {
  onDeleteProduct: () => null,
  onEditProduct: () => null,
  showNoneProduct: false,
  itemsCountPerPage: 15
}

ProductsList.propTypes = {
  productsDict: PropTypes.object.isRequired,
  productId: PropTypes.oneOfType([ PropTypes.string ]),
  onSelectProduct: PropTypes.func.isRequired,
  onDeleteProduct: PropTypes.func,
  onEditProduct: PropTypes.func,
  availableProducts: PropTypes.array.isRequired,
  showNoneProduct: PropTypes.bool,
  itemsCountPerPage: PropTypes.number
}

const mapStateToProps = (state) => {
  return {
    availableProducts: _.values(state.integrationProducts)
  }
}

export default connect(mapStateToProps)(ProductsList)



// WEBPACK FOOTER //
// ./src/components/integrations/ProductsList.js